// extracted by mini-css-extract-plugin
module.exports = {"formWidth":"NewOrganizationForm_formWidth__2dcgL"};